"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { signOut } from "@/lib/auth/client";

type LogoutButtonProps = {
	className?: string;
	label?: string;
	loggingOutLabel?: string;
};

export function LogoutButton({
	className,
	label = "Log out",
	loggingOutLabel = "Logging out…",
}: LogoutButtonProps) {
	const router = useRouter();
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	const handleLogout = async () => {
		try {
			setIsLoggingOut(true);
			await signOut({
				fetchOptions: {
					onSuccess: () => {
						router.push("/");
						router.refresh();
					},
				},
			});
		} catch (error) {
			console.error("Logout failed:", error);
		} finally {
			setIsLoggingOut(false);
		}
	};

	return (
		<button
			type="button"
			onClick={handleLogout}
			disabled={isLoggingOut}
			className={
				className ||
				"rounded-xl px-2 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-50"
			}
		>
			{isLoggingOut ? loggingOutLabel : label}
		</button>
	);
}
